import { Typography } from 'antd';
import { FC } from 'react';

import { BRAND_COLORS } from '../../../../../../constants/styles';

const { Text } = Typography;

export const StatRow: FC<{
  label: string;
  value: string | number;
  color?: string;
  bold?: boolean;
  indent?: boolean;
}> = ({ label, value, color, bold, indent }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: `5px ${indent ? '16px' : '0'}`,
    }}
  >
    <Text style={{ color: BRAND_COLORS.secondary.lightSage, fontSize: 13 }}>
      {label}
    </Text>
    <Text
      style={{
        color: color ?? '#ffffff',
        fontSize: 13,
        fontWeight: bold ? 700 : 400,
      }}
    >
      {value}
    </Text>
  </div>
);
